G.BuildEnvironment = {
  testPurchaseSdk: false,
  production: false,
  version: 'DEV',
  APP_ID: 'cookie-crush-christmas-2',
  // RAVEN_DSN: "https://4fcf77bb0b8f462883be3da572af5dfc@sentry.io/234027",
  GAGK: 'af56250b1160cfd625b6fed4575bca14',
  GASK: '2ec93f0448eb4bbcfe23d3cdf0bc2ffd0277b641',
  isCookOMT: true,

  adPlacementIDs: {
    REWARDED: '1920856321568946_1949455998708978',
    INTERSTITIAL: '1920856321568946_1949456428708935',
  },

  adPlacements: {
    skipMission: { adType: 'REWARDED', g_adName: 'skipMission' },
    spinTheDailyWheel: { adType: 'REWARDED', g_adName: 'spinTheDailyWheel' },
    requestMoveHelpWheelSpin: { adType: 'REWARDED', g_adName: 'requestMoveHelpWheelSpin' },
    claimExtraGift: { adType: 'REWARDED', g_adName: 'claimExtraGift' },
    claimAllGifts: { adType: 'REWARDED', g_adName: 'claimAllGifts' },
    achievementGift: { adType: 'REWARDED', g_adName: 'achievementGift' },
    doubleDailyReward: { adType: 'REWARDED', g_adName: 'doubleDailyReward' },
    preLevelBooster: { adType: 'REWARDED', g_adName: 'preLevelBooster' },
    retryChallenge: { adType: 'REWARDED', g_adName: 'retryChallenge' },
    addLife: { adType: 'REWARDED', g_adName: 'addLife' },
    spinTheLevelLostWheel: { adType: 'REWARDED', g_adName: 'spinTheLevelLostWheel' },
    double3hGift: { adType: 'REWARDED', g_adName: 'double3hGift' },
    doubleLevelCoins: { adType: 'REWARDED', g_adName: 'doubleLevelCoins' },
    rewarded: { adType: 'REWARDED', g_adName: 'rewarded' },
    redoMission: { adType: 'REWARDED', g_adName: 'redoMission' },
    chestShuffleRetry: { adType: 'REWARDED', g_adName: 'chestShuffle' },
    firstInterstitialInSession: { adType: 'INTERSTITIAL', g_adName: 'firstInterstitialInSession' },
    secondInterstitialInSession: { adType: 'INTERSTITIAL', g_adName: 'secondInterstitialInSession' },
    interstitial: { adType: 'INTERSTITIAL', g_adName: 'interstitial' },
  },
};
